import React, { useEffect, useState } from "react";
import AnimatedText from "components/shared/AnimatedText";
import { RouteName } from "constant/routeNames";
import { useNavigate } from "react-router-dom";

function AudioDetails({
  currentSong,
  fullScreen,
  setFullScreen,
  music,
  radio,
  podcast,
}: any) {
  const navigate = useNavigate();

  const enableFullScreenMode = () => {
    if (window.innerWidth < 640 && !radio) {
      setFullScreen(true);
    }
  };

  const handleArtistPage = () => {
    setFullScreen(false);
    navigate(
      RouteName.MusicArtistPage.replace(":slug", currentSong?.artists[0]?.slug)
    );
  };

  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {currentSong && (
        <div className="flex min-w-0 items-center gap-3">
          <img
            src={
              music || radio
                ? currentSong.artwork_url
                : podcast
                ? currentSong.podcast.artwork_url
                : ``
            }
            alt=""
            className="h-14 w-14 shrink-0 cursor-pointer rounded-lg object-cover shadow-lg ring-1 ring-white/10"
            onClick={enableFullScreenMode}
          />

          {/* song details */}
          <div className="min-w-0">
            {/* music */}
            {(music || radio) && (
              <>
                {currentSong?.title?.length > 26 ? (
                  <>
                    {music && (
                      <AnimatedText
                        text={currentSong.title}
                        classname={`text-left text-[16px] font-medium text-white scroll-text max-md:hidden`}
                      />
                    )}
                    {radio && (
                      <p className="truncate text-left text-[16px] font-medium text-white max-md:hidden">
                        {currentSong?.title}
                      </p>
                    )}
                    <p className="truncate text-left text-[16px] font-medium text-white md:hidden">
                      {`${currentSong?.title.slice(0, 26)}...`}
                    </p>
                  </>
                ) : (
                  <p className="truncate text-left text-[16px] font-medium text-white">
                    {currentSong?.title}
                  </p>
                )}
                {music && (
                  <p
                    className="mt-1 cursor-pointer truncate text-[12px] font-thin text-[#7B9DB4] transition-colors hover:text-white hover:underline max-sm:text-[11px]"
                    onClick={handleArtistPage}
                  >
                    {currentSong?.artists && currentSong?.artists[0]?.name}
                  </p>
                )}
              </>
            )}

            {/* podcast */}
            {podcast && (
              <>
                {currentSong?.title?.length > 35 ? (
                  <>
                    <AnimatedText
                      text={currentSong.title}
                      classname={`text-left text-[16px] font-medium text-white scroll-text max-md:hidden`}
                    />
                    <p className="truncate text-left text-[16px] font-medium text-white md:hidden">
                      {`${currentSong?.title.slice(0, 16)}...`}
                    </p>
                  </>
                ) : (
                  <p className="truncate text-left text-[16px] font-medium text-white">
                    {currentSong?.title}
                  </p>
                )}
                <p className="mt-1 truncate text-[12px] font-thin text-[#7B9DB4] max-sm:text-[11px]">
                  {currentSong?.artist && currentSong?.artist?.name}
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default AudioDetails;